<template>
    <div>
      <div class="text-h5">
          <v-icon large>mdi-clock</v-icon> {{ $t('reservation_time_title') }}
      </div>
      <v-list 
      :rounded="true"
      class="mt-8">
        <v-list-item
            v-for="(item,i) in timeslotlist"
            :key="i"
            @click="selecttime(item.timestart,item.timeend)"
            style="border: 4px solid #D7FF66;"
            :disabled="item.appointment>=item.seat"
        >
          <v-list-item-title >{{ item.time }} {{ item.appointment }}/{{ item.seat }}</v-list-item-title>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item>
      </v-list>
    </div>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import AppointmentSelection from '@/models/instance/AppointmentSelection.js'

export default {
  props: ['nextstep'],
  data () {
    return {
      timeslotlist : []
    }
  },
  mounted : function () {
    var que = this.$store.commit('addLoading')
    axios
    .post(config.api.url.public.appointment.get_timeslot,{group_id:AppointmentSelection.getGroupId(),date:AppointmentSelection.getDate()})
    .then(response => {
      this.timeslotlist = response.data.timeslotlist.map((i)=>{
            var timestartstr = '0000' + i.timestart;
            timestartstr = timestartstr.substring(timestartstr.length-4,timestartstr.length)
            var timeendstr = '0000' + i.timeend;
            timeendstr = timeendstr.substring(timeendstr.length-4,timeendstr.length)
            i["time"] = timestartstr.substring(0,2) + ':' + timestartstr.substring(2,4) + " - " + timeendstr.substring(0,2) + ':' + timeendstr.substring(2,4);
            return i
      })
      this.$store.commit('finishLoading',que)
    })
  },
  methods : {
    selecttime(timestart,timeend){
      AppointmentSelection.setTime(timestart,timeend)
      this.nextstep()
    }
  },
}
</script>